module.exports = __webpack_public_path__ + "img/分组 11.5def33dd.png";